import React, { useEffect, useRef, FC } from "react";

import { isNationwide } from "../../../apis/privilege";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
  Button,
  Grid,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Checkbox,
  FormControlLabel,
  Snackbar,
  SnackbarContent,
  FormGroup,
  FormControl,
  RadioGroup,
  Radio,
  Typography,
  FormLabel,
} from "@material-ui/core";

import { getFixedFlg } from "../../Header/Header";
import CloseIcon from "@material-ui/icons/Close";
import { Add } from "@material-ui/icons";
import {
  deleteTenpoCheckTemplate,
  TEMPLATE_ITEM,
  TENPO_CHECK_ITEM_TEMPLATE,
  ZENKOKU_CODE,
} from "../Register/TenpoCheckTableDataOperation";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { v4 as uuidv4 } from "uuid";
import TenpoCheckDialog from "../TenpoCheckDialog";
import { userLogging } from "../../../apis/userLog";
import TenpoCheckModalButton from "../Register/TenpoCheckModalButton";
import { getAllZone } from "../../../data/existingSejStores";
import {
  getTemplateData,
  getUseTemplateData,
  updateTenpoCheckTemplate,
  registTenpoCheckUseTemplateItem,
  updateTenpoCheckApplyTemplate,
} from "./TenpoCheckTemplateDataOperation";
import {isDmCheck, isOfcUserCheck } from "../../../apis/privilege";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalPane: {
      position: "absolute",
      paddingTop: "2%",
      paddingLeft: "20%",
      width: "60%",
      height: "60%",
      overflowX: "hidden",
    },
    modalPane2: {
      position: "absolute",
      paddingTop: "2%",
      paddingLeft: "20%",
      width: "60%",
      height: "100%",
      overflowX: "hidden",
    },
    paper: {
      height: "100%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    paper2: {
      height: "62%",
      minHeight: "60%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    titleGrid: {
      height: "7vh",
      color: "white",
      backgroundColor: "#00AC4C",
    },
    titleTypography: {
      fontWeight: "bold",
    },
    buttonSpace: {
      paddingRight: "15px",
    },
    greenButton: {
      backgroundColor: "#00CC5B",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#00CC5B",
      },
    },
    redButton: {
      backgroundColor: "#E60012",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#E60012",
      },
    }
  })
);
function setSelectItem(code: string, name: string) {
  return { code, name };
}

const MAX_ITEM_COUNT: number = 5;

  const TenpoCheckTemplateModalButton: FC<{
  onClickOK?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    recordList: any[],
    isTemplate: boolean
  ) => void;
}> = ({ onClickOK }) => {
  const classes = useStyles();
  const [newFlg, setNewFlg] = React.useState(false);
  const [editFlg, setEditFlg] = React.useState(false);
  const [quoteMode, setQuoteMode] = React.useState(false);

  const [applyingTemplate, setApplyingTemplate] = React.useState<any>();
  const [openApplyingAlert, setOpenApplyingAlert] = React.useState(false);

  const user = useSelector(selectUser);
  const [targetTemplateTitle, setTargetTemplateTitle] = React.useState("");
  const [templateList, setTemplateList] = React.useState<
    TENPO_CHECK_ITEM_TEMPLATE[]
  >([]);
  const [targetTemplate, setTargetTemplate] =
    React.useState<TENPO_CHECK_ITEM_TEMPLATE>();
  const [tmpTargetTemplate, setTmpTargetTemplate] =
    React.useState<TENPO_CHECK_ITEM_TEMPLATE>();
  const [registedTemplate, setRegistedTemplate] =
    React.useState<TENPO_CHECK_ITEM_TEMPLATE>();

  const [click, setClick] = React.useState(false);
  const [limited, isLimited] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [reload, setReload] = React.useState(false);
  const zoneMaster = getAllZone().zone_data;

  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [alertFlg, setAlertFlg] = React.useState(false);
  const [clearApplygFlg, setClearApplygFlg] = React.useState(false);

  const [useTemplateList, setUseTemplateList] = React.useState<any[]>([]);
  const [useItemList, setUseItemList] = React.useState<any[]>([]);
  const [checkedUseItemList, setCheckedUseItemList] = React.useState<any[]>([]);

  const [tmpUseTemplateName, setTmpUseTemplateName] = React.useState("");
  const [tmpUseAddTemplate, setTmpUseAddTemplate] = React.useState<any>({offense_flg:"1"});
  const [applyingClearFlg, setApplyingClearFlg] = React.useState(false);

  let zoList = [setSelectItem("", "")];
  const [targetCode, setTargetCode] = React.useState("");
  for (let i = 0; i < user.zoCode.length; i++) {
    if (zoneMaster[user.zoCode[i]]) {
      if (i === 0) {
        zoList.push(
          setSelectItem(user.zoCode[i], zoneMaster[user.zoCode[i]].zone_name)
        );
      }
    }
  }

  const alertApplyingClick = () => {
    setOpenApplyingAlert(!openApplyingAlert);
  };

  // テンプレート削除
  const deleteTemplate = () => {
    if (alertFlg) {
      setDialogFlg(false);
      return;
    }
    if (targetTemplate) {
      deleteTenpoCheckTemplate(targetTemplate.doc_id).then(() => {
        setReload(true);
        setTargetTemplateTitle("");
        setTmpTargetTemplate(undefined);
        setLoad(!load);
        setTargetTemplate(undefined);
      });
    }
    setDialogFlg(false);
  };

  const dialogClose = () => {
    setClearApplygFlg(false);
    setDialogFlg(false);
  };

  const scrollBottomRef = useRef<HTMLDivElement>(null);
  const [scrollSwitch, setScrollSwitch] = React.useState(false);

  useEffect(() => {
    setClick(!click);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetTemplate]);

  // データ取得
  useEffect(() => {
    let conditions: any[] = [];
    if (isNationwide(user)) {
      conditions.push(ZENKOKU_CODE);
    } else {
      if (user.zoCode) {
        for (const code of user.zoCode) {
          conditions.push(code);
        }
      }
      if (conditions.length === 0) {
        setLoad(!load);
        return;
      }
    }
    setTargetCode(conditions[0]);

    getUseTemplateData(conditions).then((responseMap: any) => {
      let applyDocId: string = "";
      if (responseMap) {
        applyDocId = responseMap.docID;
      }

      getTemplateData(conditions, isNationwide(user)).then(
        (response: TENPO_CHECK_ITEM_TEMPLATE[]) => {
          let tmplateList: any[] = [];

          for (const res of response) {
            tmplateList.push(res);
            if (applyDocId === res.doc_id) {
              setApplyingTemplate(res);
            }
            if (targetTemplate && targetTemplate.doc_id === res.doc_id) {
              setTargetTemplate(res);
              if (reload && registedTemplate) {
                let ckResult = true;
                if (registedTemplate.template_name !== res.template_name) {
                  ckResult = false;
                }
                if (
                  registedTemplate.small_items.length !== res.small_items.length
                ) {
                  ckResult = false;
                } else {
                  for (
                    let i = 0;
                    i < registedTemplate.small_items.length;
                    i++
                  ) {
                    if (
                      registedTemplate.small_items[i].name !==
                      res.small_items[i].name
                    ) {
                      ckResult = false;
                      break;
                    }
                  }
                }

                if (ckResult) {
                  setRegistedTemplate(undefined);
                  setReload(false);
                } else {
                  setLoad(!load);
                }
              } else {
                setReload(false);
              }
            }
          }
          setTemplateList(tmplateList);
          setClick(!click);
        }
      );
      setClick(!click);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, reload]);

  useEffect(() => {
    scrollBottomRef?.current?.scrollIntoView(false);
  }, [scrollSwitch]);

  // テンプレート名編集
  const changeTemplateTitle = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    let comment = event.target.value as string;
    if (comment && Number(comment.length) > 100) {
      comment = comment.substring(0, 100);
    }
    setTargetTemplateTitle(comment);
    setClick(!click);
  };

  // テンプレート項目名編集
  const changeTemplateItem = (
    event: React.ChangeEvent<{ value: unknown }>,
    row: TEMPLATE_ITEM
  ) => {
    if (!editFlg && !newFlg) {
      return;
    }
    let comment = event.target.value as string;
    if (comment && Number(comment.length) > 100) {
      comment = comment.substring(0, 100);
    }
    row.name = comment;
    setClick(!click);
  };

  // テンプレート登録・編集入力内容チェック
  const checkInputTemplate = () => {
    if (!targetTemplateTitle) {
      return 1;
    }

    if (tmpTargetTemplate) {
      for (let template of templateList) {
        if (
          tmpTargetTemplate.doc_id !== template.doc_id &&
          targetTemplateTitle === template.template_name
        ) {
          return 2;
        }
      }
      if (tmpTargetTemplate.small_items.length < 1) {
        return 1;
      }

      let checkTemplateNameList: string[] = [];
      for (const item of tmpTargetTemplate.small_items) {
        if (!item.name) {
          return 1;
        }
        if (checkTemplateNameList.includes(item.name)) {
          return 3;
        }
        checkTemplateNameList.push(item.name);
      }
    } else {
      return 1;
    }
    return 0;
  };

  // テンプレート新規登録・更新ボタン
  const handleRegist = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    userLogging("店舗確認表テンプレート", "テンプレート登録・更新ボタン", "");
    let checkResult: any = checkInputTemplate();
    if (checkResult === 1) {
      setAlertFlg(true);
      setDialogMessage(["未入力項目があります。入力内容を確認してください"]);
      setDialogFlg(true);
      return;
    }
    if (checkResult === 2) {
      setAlertFlg(true);
      setDialogMessage(["テンプレート名が重複しています"]);
      setDialogFlg(true);
      return;
    }
    if (checkResult === 3) {
      setAlertFlg(true);
      setDialogMessage(["項目名が重複しています。入力内容を確認してください"]);
      setDialogFlg(true);
      return;
    }
    if (tmpTargetTemplate) {
      if (tmpTargetTemplate.small_items.length > 5) {
        setAlertFlg(true);
        setDialogMessage(["入力項目は最大5件までです"]);
        setDialogFlg(true);
        return;
      }
      sortIdTmp();
      let docId = "";
      let inputId = "";
      let inputConditions: string[] = [];
      let inputBigItemId = isNationwide(user) ? 11 : 10;
      let newFlg = false;
      // 更新の場合
      if (editFlg) {
        inputId = tmpTargetTemplate.id;
        docId = tmpTargetTemplate.doc_id;
        inputConditions = tmpTargetTemplate.conditions;
        inputBigItemId = Number(tmpTargetTemplate.big_item_id);
      } else {
        // 登録の場合
        newFlg = true;
        let docCode = "";
        if (isNationwide(user)) {
          docCode = ZENKOKU_CODE;
          inputConditions.push(ZENKOKU_CODE);
        } else {
          if (user.zoCode) {
            for (const code of user.zoCode) {
              if (docCode === "") {
                docCode = code;
              }
              inputConditions.push(code);
            }
          }
        }
        let uuid = uuidv4();
        inputId = docCode + "-" + uuid;
        docId = docCode + "-" + uuid;
      }
      const registTargetTemplate: TENPO_CHECK_ITEM_TEMPLATE = {
        id: inputId,
        doc_id: docId,
        template_name: targetTemplateTitle,
        big_item_id: inputBigItemId,
        big_item_name: "商品・売場・地区政策等",
        conditions: inputConditions,
        small_items: tmpTargetTemplate.small_items,
        info: tmpTargetTemplate.info,
      };
      setRegistedTemplate(registTargetTemplate);
      updateTenpoCheckTemplate(registTargetTemplate, newFlg).then(() => {
        setReload(true);
        setTargetTemplate(registTargetTemplate);
        setTmpTargetTemplate(registTargetTemplate);
        setLoad(!load);
        setEditFlg(false);
        setNewFlg(false);
      });
    }
  };

  // キャンセル処理
  const handleClose = () => {
    userLogging("店舗確認表", "新規作成#テンプレートキャンセルボタン", "");
    setEditFlg(false);
    setNewFlg(false);
    if (targetTemplate) {
      cloneTmeTemplate(targetTemplate);
      setTargetTemplateTitle(targetTemplate.template_name);
    } else {
      setTargetTemplate(initTemplate());
    }
  };

  // 一時入力用の値をクローン
  const cloneTmeTemplate = (targetTemp: any) => {
    let cloneTemp: any = {};
    for (let key in targetTemp) {
      if (key === "small_items") {
        let smallItemList: any[] = [];
        for (let smallTmpItem of targetTemp[key]) {
          let cloneSmallItem: any = {};
          for (let smallKey in smallTmpItem) {
            cloneSmallItem[smallKey] = smallTmpItem[smallKey];
          }
          smallItemList.push(cloneSmallItem);
        }
        cloneTemp[key] = smallItemList;
      } else {
        cloneTemp[key] = targetTemp[key];
      }
    }
    setTmpTargetTemplate(cloneTemp);
  };

  // テンプレート選択
  const doSelChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    userLogging("店舗確認表", "新規作成#テンプレート選択ボタン", "");
    let value = event.target.value;
    for (let i = 0; i < templateList.length; i++) {
      if (templateList[i].id === value) {
        setTargetTemplateTitle(templateList[i].template_name);
        setTargetTemplate(templateList[i]);
        cloneTmeTemplate(templateList[i]);
        break;
      }
    }
    setClick(!click);
  };

  // テンプレート項目追加
  const clickAdd = () => {
    userLogging("店舗確認表", "新規作成#テンプレート項目追加ボタン", "");
    if (tmpTargetTemplate) {
      tmpTargetTemplate.small_items.push({
        id: 0,
        name: "",
        uuid: uuidv4(),
        photo_filepath_gcs: [],
        photo_filesize_gcs: [],
        user_input_comment: "",
        comment_filepath_gcs: [],
        comment_filesize_gcs: [],
        comment_handwrite_flag: "",
        offense_flg : "1",
        quality_level: "low",
      });
      if (tmpTargetTemplate.small_items.length > MAX_ITEM_COUNT) {
        isLimited(true);
      }
    }
    sortIdTmp();
    setClick(!click);
    setScrollSwitch(!scrollSwitch);
  };
  // テンプレート項目削除
  const clickDelete = (row: TEMPLATE_ITEM) => {
    userLogging("店舗確認表", "新規作成#テンプレート項目削除ボタン", "");
    if (tmpTargetTemplate) {
      let smallItem = [];
      for (let i = 0; i < tmpTargetTemplate.small_items.length; i++) {
        if (tmpTargetTemplate.small_items[i].id !== row.id) {
          smallItem.push(tmpTargetTemplate.small_items[i]);
        }
      }
      tmpTargetTemplate.small_items = smallItem;
      if (tmpTargetTemplate.small_items.length <= MAX_ITEM_COUNT) {
        isLimited(false);
      }
    }
    sortIdTmp();
    setClick(!click);
  };

  function sortIdTmp() {
    const newUuid = () => {
      return String(Math.random);
    };
    if (tmpTargetTemplate) {
      let smallItems: TEMPLATE_ITEM[] = [];
      for (let i = 0; i < tmpTargetTemplate.small_items.length; i++) {
        smallItems.push({
          id: i + 1,
          name: tmpTargetTemplate.small_items[i].name,
          uuid: tmpTargetTemplate.small_items[i].uuid || newUuid(),
          photo_filepath_gcs: [],
          photo_filesize_gcs: [],
          user_input_comment: "",
          comment_filepath_gcs: [],
          comment_filesize_gcs: [],
          comment_handwrite_flag: "",
          offense_flg : tmpTargetTemplate.small_items[i].offense_flg || "0",
          quality_level: "low",
        });
        tmpTargetTemplate.small_items[i].id = i + 1;
      }
    }
  }

  const initTemplate = () => {
    let template: TENPO_CHECK_ITEM_TEMPLATE = {
      id: "",
      doc_id: "",
      template_name: "",
      conditions: [],
      big_item_id: 0,
      big_item_name: "",
      small_items: [],
      info: {
        create_date: null,
        create_user: "",
        update_date: null,
        update_user: "",
      },
    };
    return template;
  };
  // 新規登録ボタン
  const clickNew = () => {
    userLogging("店舗確認表", "新規作成#テンプレート新規登録ボタン", "");
    let initTemp = initTemplate();
    let itemList: TEMPLATE_ITEM[] = [
      {
        id: 0,
        name: "",
        uuid: uuidv4(),
        photo_filepath_gcs: [],
        photo_filesize_gcs: [],
        user_input_comment: "",
        comment_filepath_gcs: [],
        comment_filesize_gcs: [],
        comment_handwrite_flag: "",
        offense_flg : "1",
        quality_level : "low",
      },
    ];
    initTemp.small_items = itemList;
    setTargetTemplateTitle("");
    setTmpTargetTemplate(initTemp);
    setEditFlg(false);
    setNewFlg(true);
    isLimited(false);
    setClick(!click);
  };

  // テンプレート編集ボタン
  const clickEdit = () => {
    userLogging("店舗確認表", "新規作成#テンプレート編集ボタン", "");
    if (targetTemplate) {
      let tmpSmallItems: TEMPLATE_ITEM[] = [];

      for (const item of targetTemplate.small_items) {
        tmpSmallItems.push(item);
      }

      cloneTmeTemplate(targetTemplate);
      setEditFlg(true);
      setNewFlg(false);
      isLimited(tmpSmallItems.length >= MAX_ITEM_COUNT);
    }
  };
  // テンプレート削除ボタン
  const clickDeleteTemplate = () => {
    userLogging("店舗確認表", "新規作成#テンプレート削除ボタン", "");
    if (targetTemplate) {
      setDialogMessage([
        "選択中のテンプレートを削除します。",
        "よろしいですか？",
      ]);
      setAlertFlg(false);
      setDialogFlg(true);
      return;
    }
  };

  // テンプレートの適用ボタン
  const clickSelectApply = () => {
    if (targetTemplate) {
      let targetCode = "";

      if (user.zoCode) {
        for (const code of user.zoCode) {
          targetCode = code;
          break;
        }
      }
      updateTenpoCheckApplyTemplate(
        targetTemplate.id,
        targetCode,
        isNationwide(user)
      );
      setApplyingClearFlg(false);
      setApplyingTemplate(targetTemplate);
      setOpenApplyingAlert(true);
      setClick(!click);
      return;
    }
  };

  // テンプレート削除ボタン
  const clickClearApply = () => {
    userLogging("店舗確認表テンプレート", "適用解除ボタン", "");
    setDialogMessage([
      "テンプレートが反映している全店舗で解除されますが、よろしいでしょうか？（ZOテンプレート：ZO全店）",
    ]);
    setAlertFlg(false);
    setDialogFlg(true);
    setClearApplygFlg(true);
    return;
  };

  // 適用解除実施
  const doClearApply = () => {
    updateTenpoCheckApplyTemplate("", targetCode, isNationwide(user));

    setApplyingClearFlg(true);
    setApplyingTemplate(null);
    setOpenApplyingAlert(true);
    setClearApplygFlg(false);
    setDialogFlg(false);
    setClick(!click);
  };

  // 既存作成テンプレート名編集
  const changeTmpUseTemplateTitle = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    let comment = event.target.value as string;
    if (comment && Number(comment.length) > 100) {
      comment = comment.substring(0, 100);
    }
    setTmpUseTemplateName(comment);
    setClick(!click);
  };

  // 既存作成の新規追加ボタン
  const clickSelectUse = () => {
    if (targetTemplate) {
      let workList = useTemplateList;
      let workItemList = useItemList;
      let workCheckedList = checkedUseItemList;
      for (let workTemplate of workList) {
        if (workTemplate.id === targetTemplate.id) {
          setClick(!click);
          return;
        }
      }

      let targetItemList = targetTemplate.small_items;
      for (let targetItem of targetItemList) {
        // 重複項目の除外
        let sameUuidFlg = false;
        for (let workItem of workItemList) {
          if (targetItem.uuid === workItem.uuid) {
            sameUuidFlg = true;
            break;
          }
        }
        if (sameUuidFlg) {
          continue;
        }
        if (!targetItem.offense_flg) {
          targetItem.offense_flg = "1";
        }
        workItemList.push(targetItem);
        if (workCheckedList.length < 5) {
          workCheckedList.push(targetItem);
        }
      }
      setCheckedUseItemList(workCheckedList);
      setUseItemList(workItemList);
      workList.push(targetTemplate);
      setUseTemplateList(workList);
    }
    setClick(!click);
  };

  // 引用作成の適用項目チェック
  const changeCheckTarget = (templateItem: any) => {
    let workCheckdUseItemList = [];
    let addFlg = true;
    for (let checkdUseItem of checkedUseItemList) {
      if (checkdUseItem.uuid === templateItem.uuid) {
        addFlg = false;
      } else {
        workCheckdUseItemList.push(checkdUseItem);
      }
    }
    if (addFlg) {
      workCheckdUseItemList.push(templateItem);
    }

    if (workCheckdUseItemList.length > 5) {
      setAlertFlg(true);
      setDialogMessage(["選択可能な項目は5つまでです"]);
      setDialogFlg(true);
      return;
    } else {
      setCheckedUseItemList(workCheckdUseItemList);
    }
    setClick(!click);
  };

  // 適用項目の表示用
  const isCheckedTargetItem = (value: string) => {
    for (let checedUseItem of checkedUseItemList) {
      if (checedUseItem.uuid === value) {
        return true;
      }
    }
    return false;
  };

  // コメント・写真
    const onPhotoClick = (
      row: TEMPLATE_ITEM,
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      comment: string,
      filePath: string[],
      fileSize: number[],
      commentFilepathGcs: string[],
      commentFilesizeGcs: number[],
      commentHandwriteFlag: string,
      qualityLevel: string
    ) => {
      userLogging("店舗確認表", "テンプレート#写真ダイアログ保存ボタン", "");
      if (!tmpTargetTemplate) return;

      const newSmallItems = tmpTargetTemplate.small_items.map((item) => {
        if (item.uuid === row.uuid) {
          return {
            ...item,
            photo_filepath_gcs: filePath,
            photo_filesize_gcs: fileSize,
            user_input_comment: comment,
            comment_filepath_gcs: commentFilepathGcs,
            comment_filesize_gcs: commentFilesizeGcs,
            comment_handwrite_flag: commentHandwriteFlag,
            quality_level: qualityLevel,
          };
        }
        return item;
      });

      setTmpTargetTemplate({
        ...tmpTargetTemplate,
        small_items: newSmallItems,
      });
  };

  // 引用作成の登録ボタン
  const clickUseSave = () => {
    if (!tmpUseTemplateName) {
      setDialogMessage(["テンプレート名を入力してください"]);
      setAlertFlg(true);
      setDialogFlg(true);
      return;
    }
    if (templateList) {
      for (let template of templateList) {
        if (tmpUseTemplateName === template.template_name) {
          setDialogMessage(["テンプレート名が重複しています"]);
          setAlertFlg(true);
          setDialogFlg(true);
          return;
        }
      }
    }
    if (!checkedUseItemList || checkedUseItemList.length === 0) {
      setDialogMessage(["項目を1件以上選択してください"]);
      setAlertFlg(true);
      setDialogFlg(true);
      return;
    }
    let checkItemNameList: any[] = [];
    for (let checkedUseItem of checkedUseItemList) {
      if (checkItemNameList.includes(checkedUseItem.name)) {
        setDialogMessage(["重複する項目名が存在します"]);
        setAlertFlg(true);
        setDialogFlg(true);
        return;
      }
      checkItemNameList.push(checkedUseItem.name);
    }

    let firstZoCode = "";
    if (isNationwide(user)) {
      firstZoCode = ZENKOKU_CODE;
    } else {
      if (user.zoCode) {
        for (const code of user.zoCode) {
          firstZoCode = code;
          break;
        }
      }
    }

    let uuid = uuidv4();
    let inputId = firstZoCode + "-" + uuid;

    registTenpoCheckUseTemplateItem(
      inputId,
      tmpUseTemplateName,
      checkedUseItemList,
      targetCode,
      isNationwide(user)
    ).then(() => {
      setReload(true);

      setTargetTemplate(undefined);
      setTmpUseTemplateName("");
      setCheckedUseItemList([]);
      setUseTemplateList([]);
      setUseItemList([]);

      setLoad(!load);
      setEditFlg(false);
      setNewFlg(false);
      setQuoteMode(false);
    });
  };

  // 引用作成のテンプレート項目名編集
  const changeUseNewTemplateItem = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    let comment = event.target.value as string;
    if (comment && Number(comment.length) > 100) {
      comment = comment.substring(0, 100);
    }
    let workTmpUseAddTemplate = tmpUseAddTemplate;
    if (!workTmpUseAddTemplate) {
      workTmpUseAddTemplate = {};
      workTmpUseAddTemplate.offense_flg = "1";
    }
    workTmpUseAddTemplate.name = comment;
    setTmpUseAddTemplate(workTmpUseAddTemplate);
    setClick(!click);
  };

  // 引用作成のファイル・写真
  const onUsePhotoClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    comment: string,
    filePath: string[],
    fileSize: number[],
    commentFilepathGcs: string[],
    commentFilesizeGcs: number[],
    commentHandwriteFlag: string,
    qualityLevel: string,
  ) => {
    let workTmpUseAddTemplate = tmpUseAddTemplate;
    if (!workTmpUseAddTemplate) {
      workTmpUseAddTemplate = {};
      workTmpUseAddTemplate.offense_flg = "1";
    }
    workTmpUseAddTemplate.photo_filepath_gcs = filePath;
    workTmpUseAddTemplate.photo_filesize_gcs = fileSize;
    workTmpUseAddTemplate.user_input_comment = comment;
    workTmpUseAddTemplate.comment_filepath_gcs = commentFilepathGcs;
    workTmpUseAddTemplate.comment_filesize_gcs = commentFilesizeGcs;
    workTmpUseAddTemplate.comment_handwrite_flag = commentHandwriteFlag;
    workTmpUseAddTemplate.quality_level = qualityLevel;
    setTmpUseAddTemplate(workTmpUseAddTemplate);
    setClick(!click);
  };

  // 引用作成の既存テンプレートの追加ボタン
  const clickTmpUseAddTemplate = () => {
    if (tmpUseAddTemplate) {
      let workTmpUseAddTemplate = tmpUseAddTemplate;
      workTmpUseAddTemplate.id = 0;
      workTmpUseAddTemplate.uuid = uuidv4();
      let workItemList = useItemList;
      let workCheckedList = checkedUseItemList;

      workItemList.push(workTmpUseAddTemplate);
      if (workCheckedList.length < 5) {
        workCheckedList.push(workTmpUseAddTemplate);
      }
      setUseItemList(workItemList);
      setCheckedUseItemList(workCheckedList);
      let workNewTemplate:any = {};
      workNewTemplate.offense_flg = "1";
      setTmpUseAddTemplate(workNewTemplate);
    }
    setClick(!click);
  };

  return (
    <>
      <Grid>
        {/* 削除確認ダイアログ */}
        <TenpoCheckDialog
          msg={dialogMessage}
          isOpen={dialogFlg}
          doOK={clearApplygFlg ? doClearApply : deleteTemplate}
          doNo={dialogClose}
          isAlert={alertFlg}
        />

        {quoteMode ? (
          <>
            <Grid container className={classes.paper}>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{
                  display: "flex",
                  color: "white",
                  backgroundColor: "#4dc0b2",
                }}
              >
                テンプレート名を入力
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{
                  display: "flex",
                  alignSelf: "center",
                  paddingTop: "10px",
                }}
              >
                <Grid item>
                  <TextField
                    placeholder="テンプレート名を入力"
                    size="small"
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: "300px" }}
                    value={tmpUseTemplateName}
                    onChange={(e) => changeTmpUseTemplateTitle(e)}
                  />{" "}
                </Grid>
                <Grid item style={{ paddingLeft: "20px" }} />
              </Grid>

              <Grid
                container
                justify="center"
                alignItems="center"
                style={{
                  marginTop: "10px",
                  marginBottom: "5px",
                  display: "flex",
                  color: "white",
                  backgroundColor: "#4dc0b2",
                }}
              >
                引継元テンプレート選択
              </Grid>

              <Grid container justify="center" alignItems="center">
                <Grid
                  item
                  style={{
                    paddingLeft: "20px",
                  }}
                >
                  <Select
                    style={{
                      minWidth: 320,
                    }}
                    onChange={(event) => doSelChange(event)}
                    value={targetTemplate ? targetTemplate.id : ""}
                    disabled={templateList.length !== 0 ? false : true}
                  >
                    {templateList.map((rowItem) => (
                      <MenuItem value={rowItem.id}>
                        {rowItem.template_name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid
                  item
                  style={{
                    paddingLeft: "20px",
                  }}
                >
                  <Button
                    style={{ width: "100px", paddingLeft: "20px" }}
                    variant="contained"
                    fullWidth={true}
                    color="primary"
                    className={classes.buttonSpace + " " + classes.greenButton}
                    onClick={() => clickSelectUse()}
                  >
                    追加
                  </Button>
                </Grid>
              </Grid>
              {tmpTargetTemplate
                ? tmpTargetTemplate.small_items.map((row) => (
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      style={{
                        display: "flex",
                        alignSelf: "flex-start",
                        paddingTop: "10px",
                      }}
                    >
                      <Grid item xs={1}>
                        {editFlg || newFlg ? (
                          <>
                            <IconButton onClick={() => clickDelete(row)}>
                              <CloseIcon />
                            </IconButton>
                          </>
                        ) : (
                          <></>
                        )}
                      </Grid>
                      <Grid item xs={10}>
                        <TextField
                          placeholder="項目名を入力"
                          size="small"
                          type="text"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          style={{ width: "70vw" }}
                          value={row.name}
                          onChange={(e) => changeTemplateItem(e, row)}
                        />
                      </Grid>
                    </Grid>
                  ))
                : ""}

              <Grid
                container
                justify="center"
                alignItems="center"
                style={{
                  display: "flex",
                  color: "white",
                  backgroundColor: "#4dc0b2",
                  marginTop: "10px",
                }}
              >
                新規入力
              </Grid>
              <Grid
                container
                justify="center"
                alignContent="center"
                style={{
                  paddingTop: "10px",
                }}
              >
                <Grid item xs={8}>
                  <TextField
                    placeholder="項目名を入力"
                    size="small"
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: "60vw" }}
                    value={
                      tmpUseAddTemplate && tmpUseAddTemplate.name
                        ? tmpUseAddTemplate.name
                        : ""
                    }
                    onChange={(e) => changeUseNewTemplateItem(e)}
                  />
                </Grid>
                <Grid item xs={1}>
                  <Grid container justify="center" alignItems="center">
                    <TenpoCheckModalButton
                      title={
                        tmpUseAddTemplate && tmpUseAddTemplate.name
                          ? tmpUseAddTemplate.name
                          : ""
                      }
                      comment={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.user_input_comment
                          ? tmpUseAddTemplate.user_input_comment
                          : ""
                      }
                      photoFilePath={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.photo_filepath_gcs
                          ? tmpUseAddTemplate.photo_filepath_gcs
                          : []
                      }
                      commentFilepath={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.comment_filepath_gcs
                          ? tmpUseAddTemplate.comment_filepath_gcs
                          : []
                      }
                      commentHandwrite={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.comment_handwrite_flag
                          ? tmpUseAddTemplate.comment_handwrite_flag
                          : ""
                      }
                      photoFileSize={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.photo_filesize_gcs
                          ? tmpUseAddTemplate.photo_filesize_gcs
                          : []
                      }
                      commentFilesize={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.comment_filesize_gcs
                          ? tmpUseAddTemplate.comment_filesize_gcs
                          : []
                      }
                      qualityLevel={
                        tmpUseAddTemplate &&
                        tmpUseAddTemplate.quality_level
                          ? tmpUseAddTemplate.quality_level
                          : ""
                      }
                      onClickSave={(
                        e,
                        comment,
                        filePath,
                        fileSize,
                        commentFilepathGcs,
                        commentFilesizeGcs,
                        commentHandwriteFlag,
                        qualityLevel
                      ) =>
                        onUsePhotoClick(
                          e,
                          comment,
                          filePath,
                          fileSize,
                          commentFilepathGcs,
                          commentFilesizeGcs,
                          commentHandwriteFlag,
                          qualityLevel
                        )
                      }
                      tenpoCode={"uuid"}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={1}>
                  <Button
                    style={{ paddingLeft: "20px" }}
                    variant="contained"
                    fullWidth={true}
                    color="primary"
                    className={classes.buttonSpace + " " + classes.greenButton}
                    onClick={() => clickTmpUseAddTemplate()}
                  >
                    追加
                  </Button>
                </Grid>
              </Grid>
              <Grid
                container
                alignContent="flex-start"
                style={{
                  display: "flex",
                  alignSelf: "flex-start",
                  paddingTop: "10px",
                }}
              >
                <Grid
                  item
                  justify="flex-start"
                  style={{
                    width: "100%",
                    border: "1px solid #000",
                  }}
                >
                  <Grid
                    item
                    style={{
                      paddingLeft: "20px",
                      color: "white",
                      backgroundColor: "#4dc0b2",
                    }}
                  >
                    選択中項目 ※最大5つまで
                  </Grid>
                  {useItemList.map((rowItem: any) => (
                    <Grid
                      container
                      justify="flex-start"
                      alignItems="flex-start"
                      style={{
                        display: "flex",
                        alignSelf: "flex-start",
                      }}
                    >
                      <Grid
                        item
                        style={{
                          paddingLeft: "20px",
                        }}
                      >
                        <Grid item>
                          <FormControlLabel
                            key={rowItem.value}
                            control={
                              <Checkbox
                                onChange={(e) => changeCheckTarget(rowItem)}
                                checked={isCheckedTargetItem(rowItem.uuid)}
                              />
                            }
                            label={rowItem.name}
                          />
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        style={{
                          paddingLeft: "20px",
                        }}
                      ></Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid
                container
                alignContent="flex-start"
                style={{
                  display: "flex",
                  alignSelf: "flex-start",
                  paddingTop: "10px",
                }}
              >
                <Grid item style={{ paddingLeft: "5px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.buttonSpace + " " + classes.greenButton}
                    onClick={() => clickUseSave()}
                  >
                    作成
                  </Button>
                </Grid>
                <Grid item justify="flex-end" style={{ paddingLeft: "15px" }}>
                  <Button
                    variant="contained"
                    fullWidth={true}
                    onClick={() => setQuoteMode(false)}
                  >
                    キャンセル
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                display: "flex",
                color: "white",
                backgroundColor: "#4dc0b2",
              }}
            >
              テンプレート{newFlg ? "登録" : editFlg ? "編集" : "選択"}
            </Grid>
            {!newFlg && !editFlg ? (
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{
                  display: "flex",
                  color: "white",
                  backgroundColor: "#4dc0b2",
                }}
              >
                (適用中テンプレート)：
                {applyingTemplate
                  ? applyingTemplate.template_name
                  : "テンプレート設定なし"}
              </Grid>
            ) : (
              ""
            )}
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                display: "flex",
                alignSelf: "flex-start",
                paddingTop: "10px",
              }}
            >
              <Grid
                item
                style={{
                  paddingLeft: "20px",
                }}
                lg={5}
                md={5}
                sm={12}
              >
                {editFlg || newFlg ? (
                  <TextField
                    placeholder="テンプレート名を入力"
                    size="small"
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    style={{ width: "300px" }}
                    value={targetTemplateTitle}
                    onChange={(e) => changeTemplateTitle(e)}
                  />
                ) : (
                  <>
                    <Grid
                      container
                      justify="flex-start"
                      alignItems="center"
                      style={{
                        display: "flex",
                        alignSelf: "flex-start",
                        paddingTop: "10px",
                      }}
                    >
                      <Grid
                        item
                        style={{
                          paddingLeft: "20px",
                        }}
                      >
                        <Select
                          style={{
                            minWidth: 320,
                          }}
                          onChange={(event) => doSelChange(event)}
                          value={targetTemplate ? targetTemplate.id : ""}
                          disabled={templateList.length !== 0 ? false : true}
                        >
                          {templateList.map((rowItem) => (
                            <MenuItem value={rowItem.id}>
                              {rowItem.template_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid item>
                {quoteMode ? (
                  ""
                ) : (
                  <Grid container style={{ paddingTop: "5px", height: "25px" }}>
                    {editFlg || newFlg ? (
                      <Grid
                        item
                        style={{
                          paddingLeft: "20px",
                        }}
                      />
                    ) : (
                      <>
                        <Grid
                          item
                          style={{
                            paddingLeft: "20px",
                          }}
                        ></Grid>
                        <Grid
                          item
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <Button
                            style={{ width: "100px" }}
                            variant="contained"
                            fullWidth={true}
                            color="primary"
                            className={
                              classes.buttonSpace + " " + classes.greenButton
                            }
                            onClick={() => clickEdit()}
                            disabled={targetTemplate ? false : true}
                          >
                            編集
                          </Button>
                        </Grid>
                        <Grid item style={{ paddingLeft: "20px" }}>
                          <Button
                            style={{ width: "100px" }}
                            variant="contained"
                            fullWidth={true}
                            color="primary"
                            className={
                              classes.buttonSpace + " " + classes.greenButton
                            }
                            onClick={() => setQuoteMode(!quoteMode)}
                          >
                            引用作成
                          </Button>
                        </Grid>
                        <Grid
                          item
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <Button
                            style={{ width: "100px" }}
                            variant="contained"
                            fullWidth={true}
                            color="primary"
                            className={
                              classes.buttonSpace + " " + classes.greenButton
                            }
                            onClick={() => clickNew()}
                          >
                            新規登録
                          </Button>
                        </Grid>
                        <Grid
                          item
                          style={{
                            paddingLeft: "20px",
                          }}
                        ></Grid>
                        <Grid
                          item
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <Button
                            style={{ width: "100px" }}
                            variant="contained"
                            fullWidth={true}
                            className={
                              classes.buttonSpace + " " + classes.redButton
                            }
                            onClick={() => clickDeleteTemplate()}
                            disabled={targetTemplate ? false : true}
                          >
                            削除
                          </Button>
                        </Grid>
                      </>
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                display: "flex",
                alignSelf: "flex-start",
                paddingTop: "10px",
              }}
            ></Grid>
            <Grid
              container
              justify="center"
              alignItems="flex-start"
              style={{
                overflowY: "auto",
                overflowX: "hidden",
                width: "100%",
                height: "40%",
              }}
            >
              <Grid
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                  height: "50%",
                }}
              >
                {tmpTargetTemplate
                  ? tmpTargetTemplate.small_items.map((row) => (
                      <Grid
                        container
                        justify="center"
                        alignItems="center"
                        style={{
                          display: "flex",
                          alignSelf: "flex-start",
                          paddingTop: "10px",
                        }}
                      >
                        <Grid item xs={1}>
                          {editFlg || newFlg ? (
                            <>
                              <IconButton onClick={() => clickDelete(row)}>
                                <CloseIcon />
                              </IconButton>
                            </>
                          ) : (
                            <></>
                          )}
                        </Grid>
                        <Grid item xs={8}>
                          <TextField
                            placeholder="項目名を入力"
                            size="small"
                            type="text"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            style={{ width: "60vw" }}
                            value={row.name}
                            onChange={(e) => changeTemplateItem(e, row)}
                          />
                        </Grid>
                        {editFlg || newFlg ? (
                          <>
                            <Grid item xs={1} key={row.id + "_upload"}>
                              <Grid
                                container
                                justify="center"
                                alignItems="center"
                              >
                                <TenpoCheckModalButton
                                  title={row.name}
                                  comment={
                                    row.user_input_comment
                                      ? row.user_input_comment
                                      : ""
                                  }
                                  photoFilePath={
                                    row.photo_filepath_gcs
                                      ? row.photo_filepath_gcs
                                      : []
                                  }
                                  photoFileSize={
                                    row.photo_filesize_gcs
                                      ? row.photo_filesize_gcs
                                      : []
                                  }
                                  commentFilepath={
                                    row.comment_filepath_gcs
                                      ? row.comment_filepath_gcs
                                      : []
                                  }
                                  commentFilesize={
                                    (row as any).comment_filesize_gcs
                                      ? (row as any).comment_filesize_gcs
                                      : []
                                  }
                                  commentHandwrite={
                                    row.comment_handwrite_flag
                                      ? row.comment_handwrite_flag
                                      : ""
                                  }
                                  qualityLevel={
                                    row.quality_level
                                      ? row.quality_level
                                      : "low"
                                  }
                                  onClickSave={(
                                    e,
                                    comment,
                                    filePath,
                                    fileSizes,
                                    commentFilepathGcs,
                                    commentFilesizeGcs,
                                    commentHandwriteFlag,
                                    qualityLevel
                                  ) =>
                                    onPhotoClick(
                                      row,
                                      e,
                                      comment,
                                      filePath,
                                      fileSizes,
                                      commentFilepathGcs,
                                      commentFilesizeGcs,
                                      commentHandwriteFlag,
                                      qualityLevel
                                    )
                                  }
                                  tenpoCode={row.uuid}
                                  isTemplate={true}
                                />
                              </Grid>
                            </Grid>
                          </>
                        ) : (
                          ""
                        )}
                      </Grid>
                    ))
                  : ""}
                <Grid container justify="center" ref={scrollBottomRef}></Grid>
              </Grid>

              {editFlg || newFlg ? (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{
                    display: "flex",
                    alignSelf: "flex-start",
                    paddingTop: "10px",
                  }}
                >
                  <IconButton
                    onClick={clickAdd}
                    disabled={limited}
                    className={classes.greenButton}
                    style={
                      limited
                        ? { color: "#fff", backgroundColor: "#C4C4C4" }
                        : {}
                    }
                  >
                    <Add></Add>
                  </IconButton>
                </Grid>
              ) : (
                ""
              )}
            </Grid>

            <Grid container justify="center">
              {editFlg || newFlg ? (
                <>
                  <Grid item xs={6}>
                    <Grid container justify="center">
                      <Button
                        style={{ width: "20vw" }}
                        variant="contained"
                        fullWidth={true}
                        onClick={handleClose}
                      >
                        キャンセル
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container justify="center">
                      {getFixedFlg() ? (
                        ""
                      ) : (
                        <Button
                          style={{ width: "20vw" }}
                          className={classes.greenButton}
                          variant="contained"
                          fullWidth={true}
                          onClick={(e) => handleRegist(e)}
                          color="primary"
                          disabled={tmpTargetTemplate ? false : true}
                        >
                          {newFlg ? "登録" : "更新"}
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid
                    container
                    justify="center"
                    style={{
                      display: "flex",
                      alignSelf: "flex-start",
                      paddingTop: "10px",
                    }}
                  >
                    <Grid item justify="center" lg={10} sm={9}>
                      <Grid container justify="center" alignItems="center">
                        <Button
                          style={{ width: "100px", paddingLeft: "20px" }}
                          variant="contained"
                          fullWidth={true}
                          color="primary"
                          className={
                            classes.buttonSpace + " " + classes.greenButton
                          }
                          onClick={() => clickSelectApply()}
                        >
                          適用
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Button
                        style={{ width: "180px", paddingLeft: "20px" }}
                        variant="contained"
                        fullWidth={true}
                        color="primary"
                        className={
                          classes.buttonSpace + " " + classes.redButton
                        }
                        onClick={() => clickClearApply()}
                      >
                        テンプレート適用解除
                      </Button>
                    </Grid>
                  </Grid>

                  <Snackbar
                    open={openApplyingAlert}
                    autoHideDuration={5000}
                    onClose={alertApplyingClick}
                  >
                    <SnackbarContent
                      style={{ backgroundColor: "#333333", color: "white" }}
                      message={
                        <span style={{ fontSize: "16px" }}>
                          {applyingClearFlg
                            ? "テンプレートの適用が解除されました"
                            : "テンプレートが正常に適用されました"}
                        </span>
                      }
                    />
                  </Snackbar>
                </>
              )}
            </Grid>
            {/*  テンプレート選択モーダル↑ここまで*/}
          </>
        )}
      </Grid>
    </>
  );
};
export default TenpoCheckTemplateModalButton;
